import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, InvoiceService, ReportService, UtilityService } from 'app/core/core.module';
import { Invoice, InvoiceStatus } from 'app/core/model/entity-model';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InvoiceOrderDialogComponent } from '../invoice-order-dialog/invoice-order-dialog.component';

@Component({
    selector: 'app-invoice-search',
    templateUrl: './invoice-search.component.html',
    styleUrls: ['./invoice-search.component.scss'],
    standalone: false
})
export class InvoiceSearchComponent implements OnInit {
    invoices: any;
    filter: any;
    showCompleted = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private reportService: ReportService,
        private utility: UtilityService,
        private invoiceService: InvoiceService
    ) {}

    async ngOnInit() {
        const dealers = await this.uow.dealers.all(null, 'salesRep');
        const statuses = await this.uow.lookups.orderLineStatuses;
        const invoiceStatuses = await this.uow.lookups.invoiceStatuses;
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const invoices = (await this.uow.getOpenInvoicesForSearch(
            'dealer,invoiceLines.orderLineDetail.packingSlip, invoiceLines.orderLineDetail.orderLine.order, invoiceLines.orderLineDetail.paymentLines'
        )) as Invoice[];
        this.invoices = invoices;
        this.appInfo.pleaseWaitHide();
    }

    async printHyperlink(cell: any) {
        // if (cell.column.dataField === 'packingSlipNumber') {
        //     const reportGuid = ((await this.uow.getPackSlipByNumber(cell.value)) as PackingSlip).reportGuid;
        //     this.reportService.openPackingSlip([reportGuid]);
        // }
        // if (cell.column.dataField === 'invoiceNumber') {
        //     const reportGuid = ((await this.uow.getPackSlipByInvoiceNumber(cell.value)) as PackingSlip).reportGuid;
        //     this.reportService.openInvoiceReport([reportGuid]);
        // }
    }

    async print() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        if (selectedRows[0].reportGuid === null) {
            selectedRows[0].reportGuid = crypto.randomUUID();
            await this.uow.commit();
        }

        const reportGuids = selectedRows.map((x) => x.reportGuid);
        this.reportService.openInvoiceWithBalanceReport(reportGuids);
    }



    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.canExport && e.data.quickBooksId) {
                e.rowElement.className = e.rowElement.className + ' uncompleted-details';
            }
            if (e.data.readyToExport && !e.data.quickBooksId) {
                e.rowElement.className = e.rowElement.className + ' invoice-ready-to-export';
            }
            if (e.data.quickBooksId && !e.data.quickBooksLastExport) {
                e.rowElement.className = e.rowElement.className + ' invoice-update-ready-to-export ';
            }
        }
    }

    async open(id: number) {
        this.router.navigate(['/sales-orders/' + (!!id ? id : 'new')]);
    }

    async openInvoice(id: number) {
        this.router.navigate([`invoices/${id}`]);
    }

    async openInvoiceOrder(invoiceNumber: number) {
        const order = (await this.uow.getOrdersByInvoiceNumbers([invoiceNumber]))[0];
        if (!order) return;
        await this.open(order.id);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.openInvoice(e.data.id);
    }

    async orderDialog(invoiceNumbers: any) {
        const modalRef = this.modalService.show(InvoiceOrderDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                invoiceNumbers: invoiceNumbers,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && !!result.value) {
                await this.open(result.value);
            }
            modalRef.hide();
        });
    }

    async readyToExport() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length === 0) return;

        await this.invoiceService.readyToExport(selectedRows);
        await this.getData();
    }


    async receivePayment() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        this.invoiceService.receivePayment(selectedRows[0]);
    }

    async emailInvoice() {
        const invoice = this.dataGrid.instance.getSelectedRowsData()[0] as Invoice;
        if (!invoice) return;

        const body = ((await this.uow.getSettingsByName('InvoiceEmailBody')) as any).stringValue;

        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'Invoice',
                entityId: invoice.id,
                dealerEmail: invoice.dealer.aPEmail ?? invoice.dealer.email,
                body: body,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && !!result.value) {
                this.appInfo.pleaseWaitShow();
                const emailSent = await this.utility.emailReport(result.value);
                invoice.emailed = new Date();
                await this.uow.commit();
                this.appInfo.pleaseWaitHide();
                await alert(emailSent ? 'Email Sent!' : 'An error occurred while sending the email.', this.appInfo.settings.company);
            }
            modalRef.hide();
        });
    }

    async payWithoutQuickBooks() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const success = await confirm(
            `Are you sure you want to mark the selected ${selectedRows.length === 1 ? 'line' : 'lines'} as Paid w/o QuickBooks?`,
            this.appInfo.settings.company
        );
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((line) => {
            line.quickBooksId = 'Paid w/o QuickBooks';
            line.quickBooksLastExport = new Date();
        });
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
    }

    async updateStatus() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length === 0) return;

        const invoiceStatuses = this.uow.lookups.invoiceStatuses;

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Update Status',
                dialogPrompt: 'Select Status',
                mode: 'selectWithId',
                dialogValueArray: invoiceStatuses,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                this.appInfo.pleaseWaitShow();
                selectedRows.forEach((row) => {
                    row.statusId = result.value;
                    if (result.value === InvoiceStatus.Statuses.Paid && !row.paid) row.paid = new Date();
                });
                await this.uow.commit();
                this.appInfo.pleaseWaitHide();
                // await this.getData();
            }
            modalRef.hide();
        });
    }
}
